import * as React from 'react'
import Button from '../components/Button'
import Typography from '../components/Typography'
import ProductHeroLayout from './ProductHeroLayout'

const backgroundImage =
  '/static/church/241020772_4257319104363645_7959890029981460225_n.jpg'

export default function ProductHero() {
    return (
        <ProductHeroLayout
            sxBackground={{
                backgroundImage: `url(${backgroundImage})`,
                backgroundColor: '#7fc7d9', // Average color of the background image.
                backgroundPosition: 'center',
            }}
            >
            <img
                style={{ display: 'none' }}
                src={backgroundImage}
                alt="increase priority"
                />
            <Typography color="inherit" align="center" variant="h2" marked="center">
                TO BRING GLORY TO GOD
            </Typography>
            <Typography
                color="inherit"
                align="center"
                variant="h5"
                sx={{ mb: 4, mt: { xs: 4, sm: 10 } }}>
                Vibrant community church where people of all backgrounds come together to worship.
            </Typography>
            {/* <Button
                color="secondary"
                variant="contained"
                size="large"
                component="a"
                href="/"
                sx={{ minWidth: 200 }}
                >
                Join Us
            </Button> */}
        </ProductHeroLayout>
    )
}
